import { render, staticRenderFns } from "./HomeIcon.vue?vue&type=template&id=36b90b02&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/packages/axiom-design-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36b90b02')) {
      api.createRecord('36b90b02', component.options)
    } else {
      api.reload('36b90b02', component.options)
    }
    module.hot.accept("./HomeIcon.vue?vue&type=template&id=36b90b02&", function () {
      api.rerender('36b90b02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/04-web-components/powerbar/assets/icons/HomeIcon.vue"
export default component.exports